import PageOptions from "@/config/PageOptions.vue";
import packageJson from "../../../package.json";

const PRODUCT_ASSETS = {
  mixora: {
    icon: "/assets/img/solo_icono.png",
    heroImage: "/assets/img/logo_base.png",
    heroLetters: "/assets/img/letras_logo.png",
    useLogoStack: true,
  },
  opt: {
    icon: "/assets/img/solo_icono.png",
    heroImage: "/assets/img/logo_base.png",
    heroLetters: "/assets/img/letras_logo.png",
    useLogoStack: false,
  },
};

function resolveProductKey() {
  const envProduct = (process.env.VUE_APP_PRODUCT || "")
    .replace(/['"]/g, "")
    .trim()
    .toLowerCase();

  if (envProduct === "mixora" || envProduct === "opt") {
    return envProduct;
  }

  return packageJson.name === "mixora" ? "mixora" : "opt";
}

function resolveSisterProductUrl() {
  return (process.env.VUE_APP_SISTER_PRODUCT_URL || "")
    .replace(/['"]/g, "")
    .trim();
}

export default {
  name: "LandingPage",
  data() {
    const productKey = resolveProductKey();

    return {
      productKey,
      sisterKey: productKey === "opt" ? "mixora" : "opt",
      sisterProductUrl: resolveSisterProductUrl(),
      productAssets: PRODUCT_ASSETS,
      featureIcons: ["fa-fill-drip", "fa-palette", "fa-sliders-h"],
    };
  },
  computed: {
    primaryAssets() {
      return this.productAssets[this.productKey];
    },
    secondaryAssets() {
      return this.productAssets[this.sisterKey];
    },
    primaryProductName() {
      return this.$t(`landing.products.${this.productKey}.shortName`);
    },
    primaryBrandLine() {
      return this.$t(`landing.products.${this.productKey}.brandLine`);
    },
    secondaryProductName() {
      return this.$t(`landing.products.${this.sisterKey}.shortName`);
    },
    primaryFeatures() {
      return [1, 2, 3].map((index) => ({
        icon: this.featureIcons[index - 1],
        title: this.$t(
          `landing.products.${this.productKey}.feature${index}Title`
        ),
        text: this.$t(
          `landing.products.${this.productKey}.feature${index}Text`
        ),
      }));
    },
    comparisonRows() {
      return [this.productKey, this.sisterKey].map((key) => ({
        key,
        isPrimary: key === this.productKey,
        name: this.$t(`landing.products.${key}.shortName`),
        inkLine: this.$t(`landing.products.${key}.inkLine`),
      }));
    },
    hasSisterLink() {
      return Boolean(this.sisterProductUrl);
    },
    copyrightYear() {
      return new Date().getFullYear();
    },
    copyrightLine() {
      return `© ${this.primaryBrandLine} - ${this.$t(
        "messages.copyrightCompany"
      )}${this.$t("messages.allRightsReserved")}${this.copyrightYear}`;
    },
  },
  created() {
    PageOptions.pageEmpty = true;
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false;
    next();
  },
  mounted() {
    if (
      process.env.VUE_APP_ENVIRONMENT === "PRODUCTION" &&
      location.protocol !== "https:"
    ) {
      location.replace(
        `https:${location.href.substring(location.protocol.length)}`
      );
      return;
    }

    const persona = JSON.parse(localStorage.getItem("persona"));
    const token = localStorage.getItem("token");
    if (persona && token) {
      this.$router.replace("/app");
    }
  },
};
